import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getPatientData} from '../services/getPatientData';

export const useGetPatientDataQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.HOSPITALIZATION_PATIENT_DATA],
		queryFn: ({signal}) => getPatientData(signal),
	});
